export const en = {
  'shell.nav.leads': 'Leads',
  'enum.leadStage.NEW': 'New',
  'enum.leadStage.CONTACTED': 'Contacted',
  'enum.leadStage.TOUR_BOOKED': 'Tour booked',
  'enum.leadStage.TRIAL': 'Trial',
  'enum.leadStage.WON': 'Won',
  'enum.leadStage.LOST': 'Lost',
  'enum.leadSource.WEBSITE_FORM': 'Website form',
  'enum.leadSource.WALK_IN': 'Walk-in',
  'enum.leadSource.PHONE': 'Phone',
  'enum.leadSource.REFERRAL': 'Referral',
  'enum.leadSource.CAMPAIGN': 'Campaign',
  'enum.leadSource.SOCIAL': 'Social media',
  'enum.leadSource.OTHER': 'Other',

  'leads.title': 'Leads',
  'leads.description': 'People who asked about the gym or walked in, from the first contact until they join.',
  'leads.add': 'Add walk-in',
  'leads.addTitle': 'Add a lead',
  'leads.addDescription': 'A name and a way to reach them are enough; the rest can wait.',
  'leads.created': 'Lead added',
  'leads.tab.board': 'Board',
  'leads.tab.list': 'List',
  'leads.tab.report': 'Conversion',
  'leads.searchPlaceholder': 'Search by name, phone, email or interest',
  'leads.anySource': 'Any source',
  'leads.anyStage': 'Any stage',
  'leads.openStages': 'Still open',
  'leads.anyone': 'Anyone',
  'leads.mine': 'Assigned to me',
  'leads.unassigned': 'Unassigned',
  'leads.anyBranch': 'Any branch',
  'leads.anyFollowUp': 'Any follow-up',
  'leads.followUp.TODAY': 'Due today',
  'leads.followUp.OVERDUE': 'Overdue',
  'leads.followUp.DUE': 'Due today or overdue',
  'leads.clearFilters': 'Clear filters',
  'leads.empty': 'No leads yet',
  'leads.emptyHint': 'Website enquiries appear here on their own; add walk-ins as they come in.',
  'leads.noMatch': 'No leads match',
  'leads.noMatchHint': 'Try another search or clear the filters.',
  'leads.stage': 'Stage',
  'leads.source': 'Source',
  'leads.assignee': 'Assigned to',
  'leads.branch': 'Branch',
  'leads.followUp': 'Next follow-up',
  'leads.interest': 'Interested in',
  'leads.interestPlaceholder': 'Personal training, a morning plan…',
  'leads.notes': 'Notes',
  'leads.added': 'Added',
  'leads.addedOn': 'Added {date}',
  'leads.nobody': 'Nobody',
  'leads.noBranch': 'No branch',
  'leads.due.TODAY': 'Due today',
  'leads.due.OVERDUE': 'Overdue',
  'leads.lostBecause': 'Lost: {reason}',
  'leads.member': 'Member: {name}',
  'leads.nextAppointment': '{type} · {when}',
  'leads.appointments.title': 'Tours and consultations',
  'leads.appointments.book': 'Book a tour',
  'leads.appointments.empty': 'Nothing booked yet. Book a tour or consultation, and the lead moves to Tour booked.',
  'leads.activity.APPOINTMENT': 'Tour or consultation',
  'leads.activity.APPOINTMENT.BOOKED': '{type} booked for {when} with {host}',
  'leads.activity.APPOINTMENT.COMPLETED': 'Came to the {type} on {when}',
  'leads.activity.APPOINTMENT.NO_SHOW': 'Did not come to the {type} on {when}',
  'leads.activity.APPOINTMENT.CANCELLED': '{type} on {when} cancelled',
  'leads.activity.movedTo': 'Moved to {stage}',

  'leads.board.label': 'Leads by stage',
  'leads.board.empty': 'Nothing here',
  'leads.board.more': '{count} more in the list',
  'leads.board.handle': 'Move {name}',
  'leads.board.moveTo': 'Move {name} to',
  'leads.board.instructions': 'Press Space or Enter to pick up a lead, the left and right arrows to choose a stage, Space or Enter to drop it there, or Escape to leave it where it was.',
  'leads.board.picked': 'Picked up {name} from {stage}.',
  'leads.board.over': '{name} is over {stage}.',
  'leads.board.dropped': '{name} dropped on {stage}.',
  'leads.board.cancelled': '{name} stays in {stage}.',
  'leads.moved': '{name} moved to {stage}',

  'leads.lost.title': 'Why was {name} lost?',
  'leads.lost.description': 'The reason shows on the lead, in its timeline and in the conversion report.',
  'leads.lost.label': 'Reason',
  'leads.lost.placeholder': 'Too expensive, chose another gym…',
  'leads.lost.confirm': 'Mark as lost',

  'leads.convert.action': 'Make a member',
  'leads.convert.title': 'Make {name} a member',
  'leads.convert.description': 'The form starts from the lead; check it before saving. The lead is then won and linked to the member.',
  'leads.convert.new': 'New member',
  'leads.convert.existing': 'Already a member',
  'leads.convert.member': 'Member',
  'leads.convert.confirm': 'Make a member',
  'leads.convert.link': 'Link the member',
  'leads.convert.done': '{name} is a member now',

  'leads.back': 'All leads',
  'leads.details': 'Details',
  'leads.saved': 'Lead saved',
  'leads.move': 'Move',
  'leads.moveTo': 'Move to',
  'leads.openMember': 'Open the member',
  'leads.timeline': 'Timeline',
  'leads.timelineEmpty': 'Nothing has happened yet.',
  'leads.note.title': 'Add to the timeline',
  'leads.note.kind': 'What it was',
  'leads.note.kind.NOTE': 'Note',
  'leads.note.kind.CALL': 'Call',
  'leads.note.text': 'What happened',
  'leads.note.placeholder': 'Called, will come for a tour on Friday…',
  'leads.note.save': 'Add',
  'leads.note.saved': 'Added to the timeline',
  'leads.activity.CREATED': 'Added, from {source}',
  'leads.activity.STAGE_CHANGED': 'Moved from {from} to {to}',
  'leads.activity.NOTE': 'Note',
  'leads.activity.enquiry': 'Wrote again through the website',
  'leads.activity.CALL': 'Call',
  'leads.activity.ASSIGNED': 'Given to {name}',
  'leads.activity.unassigned': 'No longer assigned to anyone',
  'leads.activity.FOLLOW_UP': 'Next follow-up set for {when}',
  'leads.activity.followUpCleared': 'Next follow-up cleared',
  'leads.activity.UPDATED': 'Changed {fields}',
  'leads.activity.CONVERTED': 'Became member {name}',
  'leads.activity.MATCHED.phone': 'Became member {name}: the desk added someone with the same phone',
  'leads.activity.MATCHED.email': 'Became member {name}: the desk added someone with the same email',
  'leads.activity.lostReason': 'Reason: {reason}',
  'leads.activity.website': 'Website',
  'leads.activity.system': 'Bulk',
  'leads.field.name': 'name',
  'leads.field.phone': 'phone',
  'leads.field.email': 'email',
  'leads.field.source': 'source',
  'leads.field.interest': 'interest',
  'leads.field.locationId': 'branch',
  'leads.field.notes': 'notes',

  'leads.dashboard.dueToday': 'Lead follow-ups today',
  'leads.dashboard.overdue': '{count} overdue',
  'leads.dashboard.noneOverdue': 'None overdue',

  'leads.report.title': 'Who converts, and where they come from',
  'leads.report.description': 'Leads that came in during the period and what became of them since.',
  'leads.report.groupBy': 'Show by',
  'reports.dataset.leads': 'Leads',
  'reports.grouping.source': 'Source',
  'reports.measure.leads': 'Leads',
  'reports.measure.won': 'Won',
  'reports.measure.lost': 'Lost',
  'reports.measure.conversion': 'Conversion rate',
  'reports.unassigned': 'Unassigned',
  'reports.builtIn.leadsBySource': 'Lead conversion by source',

  'admin.apiError.LOST_REASON_REQUIRED': 'Say why the lead was lost.',
  'admin.apiError.LEAD_CONVERTED': 'This lead is already a member.',
  'admin.apiError.LEAD_WON_BY_CONVERTING': 'A lead is won by making it a member.',
  'admin.apiError.ASSIGNEE_NOT_ALLOWED': 'Leads can be given only to staff who work with them.',
};

export const ka: Record<keyof typeof en, string> = {
  'shell.nav.leads': 'ლიდები',
  'enum.leadStage.NEW': 'ახალი',
  'enum.leadStage.CONTACTED': 'დაკავშირებული',
  'enum.leadStage.TOUR_BOOKED': 'დათვალიერება დაგეგმილია',
  'enum.leadStage.TRIAL': 'საცდელი ვიზიტი',
  'enum.leadStage.WON': 'გაწევრიანდა',
  'enum.leadStage.LOST': 'დაკარგული',
  'enum.leadSource.WEBSITE_FORM': 'ვებგვერდის ფორმა',
  'enum.leadSource.WALK_IN': 'პირადად მოვიდა',
  'enum.leadSource.PHONE': 'ტელეფონი',
  'enum.leadSource.REFERRAL': 'რეკომენდაცია',
  'enum.leadSource.CAMPAIGN': 'კამპანია',
  'enum.leadSource.SOCIAL': 'სოციალური ქსელები',
  'enum.leadSource.OTHER': 'სხვა',

  'leads.title': 'ლიდები',
  'leads.description': 'ადამიანები, ვინც დარბაზით დაინტერესდა ან პირადად მოვიდა — პირველი კონტაქტიდან გაწევრიანებამდე.',
  'leads.add': 'ვიზიტორის დამატება',
  'leads.addTitle': 'ლიდის დამატება',
  'leads.addDescription': 'საკმარისია სახელი და საკონტაქტო მონაცემი; დანარჩენს მოგვიანებით დაამატებთ.',
  'leads.created': 'ლიდი დაემატა',
  'leads.tab.board': 'დაფა',
  'leads.tab.list': 'სია',
  'leads.tab.report': 'კონვერსია',
  'leads.searchPlaceholder': 'ძიება სახელით, ტელეფონით, ელფოსტით ან ინტერესით',
  'leads.anySource': 'ნებისმიერი წყარო',
  'leads.anyStage': 'ნებისმიერი ეტაპი',
  'leads.openStages': 'მიმდინარე',
  'leads.anyone': 'ყველა',
  'leads.mine': 'ჩემზე მიმაგრებული',
  'leads.unassigned': 'მიუმაგრებელი',
  'leads.anyBranch': 'ნებისმიერი ფილიალი',
  'leads.anyFollowUp': 'ნებისმიერი ვადა',
  'leads.followUp.TODAY': 'დღეს',
  'leads.followUp.OVERDUE': 'ვადაგადაცილებული',
  'leads.followUp.DUE': 'დღეს ან ვადაგადაცილებული',
  'leads.clearFilters': 'ფილტრების გასუფთავება',
  'leads.empty': 'ლიდები ჯერ არ არის',
  'leads.emptyHint': 'ვებგვერდიდან მოსული მოთხოვნები აქ თავისით ჩნდება; ვიზიტორები დაამატეთ, როგორც კი მოვლენ.',
  'leads.noMatch': 'შესაბამისი ლიდი ვერ მოიძებნა',
  'leads.noMatchHint': 'სცადეთ სხვა ძიება ან გაასუფთავეთ ფილტრები.',
  'leads.stage': 'ეტაპი',
  'leads.source': 'წყარო',
  'leads.assignee': 'პასუხისმგებელი',
  'leads.branch': 'ფილიალი',
  'leads.followUp': 'შემდეგი კონტაქტი',
  'leads.interest': 'რით დაინტერესდა',
  'leads.interestPlaceholder': 'პერსონალური ვარჯიში, დილის აბონემენტი…',
  'leads.notes': 'შენიშვნები',
  'leads.added': 'დამატებულია',
  'leads.addedOn': 'დამატებულია {date}',
  'leads.nobody': 'არავინ',
  'leads.noBranch': 'ფილიალის გარეშე',
  'leads.due.TODAY': 'დღეს',
  'leads.due.OVERDUE': 'ვადაგადაცილებული',
  'leads.lostBecause': 'დაიკარგა: {reason}',
  'leads.member': 'წევრი: {name}',
  'leads.nextAppointment': '{type} · {when}',
  'leads.appointments.title': 'ტურები და კონსულტაციები',
  'leads.appointments.book': 'ტურის დაჯავშნა',
  'leads.appointments.empty': 'ჯერ არაფერია დაჯავშნილი. დაჯავშნეთ ტური ან კონსულტაცია და ლიდი ეტაპზე „ტური დაჯავშნილია“ გადავა.',
  'leads.activity.APPOINTMENT': 'ტური ან კონსულტაცია',
  'leads.activity.APPOINTMENT.BOOKED': '„{type}“ დაიჯავშნა: {when}, {host}',
  'leads.activity.APPOINTMENT.COMPLETED': 'მოვიდა „{type}“-ზე ({when})',
  'leads.activity.APPOINTMENT.NO_SHOW': 'არ მოვიდა „{type}“-ზე ({when})',
  'leads.activity.APPOINTMENT.CANCELLED': '„{type}“ ({when}) გაუქმდა',
  'leads.activity.movedTo': 'გადავიდა ეტაპზე „{stage}“',

  'leads.board.label': 'ლიდები ეტაპების მიხედვით',
  'leads.board.empty': 'ცარიელია',
  'leads.board.more': 'სიაში კიდევ {count}',
  'leads.board.handle': '{name} — გადატანა',
  'leads.board.moveTo': '{name} — გადატანა ეტაპზე',
  'leads.board.instructions': 'ლიდის ასაღებად დააჭირეთ Space-ს ან Enter-ს, ეტაპი აირჩიეთ მარცხენა და მარჯვენა ისრებით, ჩასადებად კვლავ დააჭირეთ Space-ს ან Enter-ს, გასაუქმებლად — Escape-ს.',
  'leads.board.picked': '{name} აღებულია ეტაპიდან „{stage}“.',
  'leads.board.over': '{name} ეტაპზეა „{stage}“.',
  'leads.board.dropped': '{name} გადატანილია ეტაპზე „{stage}“.',
  'leads.board.cancelled': '{name} რჩება ეტაპზე „{stage}“.',
  'leads.moved': '{name} გადატანილია ეტაპზე „{stage}“',

  'leads.lost.title': 'რატომ დაიკარგა {name}?',
  'leads.lost.description': 'მიზეზი გამოჩნდება ლიდის ბარათზე, მის ქრონოლოგიასა და კონვერსიის ანგარიშში.',
  'leads.lost.label': 'მიზეზი',
  'leads.lost.placeholder': 'ძალიან ძვირია, სხვა დარბაზი აირჩია…',
  'leads.lost.confirm': 'დაკარგულად მონიშვნა',

  'leads.convert.action': 'წევრად რეგისტრაცია',
  'leads.convert.title': '{name} — წევრად რეგისტრაცია',
  'leads.convert.description': 'ფორმა ლიდის მონაცემებით ივსება; შენახვამდე გადაამოწმეთ. ამის შემდეგ ლიდი გაწევრიანებულად მოინიშნება და წევრს დაუკავშირდება.',
  'leads.convert.new': 'ახალი წევრი',
  'leads.convert.existing': 'უკვე წევრია',
  'leads.convert.member': 'წევრი',
  'leads.convert.confirm': 'წევრად რეგისტრაცია',
  'leads.convert.link': 'წევრთან დაკავშირება',
  'leads.convert.done': '{name} ახლა წევრია',

  'leads.back': 'ყველა ლიდი',
  'leads.details': 'დეტალები',
  'leads.saved': 'ლიდი შენახულია',
  'leads.move': 'გადატანა',
  'leads.moveTo': 'გადატანა ეტაპზე',
  'leads.openMember': 'წევრის გახსნა',
  'leads.timeline': 'ქრონოლოგია',
  'leads.timelineEmpty': 'ჯერ არაფერი მომხდარა.',
  'leads.note.title': 'ქრონოლოგიაში დამატება',
  'leads.note.kind': 'რა იყო',
  'leads.note.kind.NOTE': 'შენიშვნა',
  'leads.note.kind.CALL': 'ზარი',
  'leads.note.text': 'რა მოხდა',
  'leads.note.placeholder': 'დავურეკე, პარასკევს მოვა დარბაზის დასათვალიერებლად…',
  'leads.note.save': 'დამატება',
  'leads.note.saved': 'დაემატა ქრონოლოგიაში',
  'leads.activity.CREATED': 'დაემატა, წყარო: {source}',
  'leads.activity.STAGE_CHANGED': 'გადავიდა ეტაპიდან „{from}“ ეტაპზე „{to}“',
  'leads.activity.NOTE': 'შენიშვნა',
  'leads.activity.enquiry': 'ვებგვერდიდან ხელახლა მოგვწერა',
  'leads.activity.CALL': 'ზარი',
  'leads.activity.ASSIGNED': 'გადაეცა: {name}',
  'leads.activity.unassigned': 'აღარავისზეა მიმაგრებული',
  'leads.activity.FOLLOW_UP': 'შემდეგი კონტაქტი: {when}',
  'leads.activity.followUpCleared': 'შემდეგი კონტაქტი მოხსნილია',
  'leads.activity.UPDATED': 'შეიცვალა: {fields}',
  'leads.activity.CONVERTED': 'გაწევრიანდა: {name}',
  'leads.activity.MATCHED.phone': 'გაწევრიანდა: {name} — მიმღებმა იმავე ტელეფონის ნომრით დაარეგისტრირა',
  'leads.activity.MATCHED.email': 'გაწევრიანდა: {name} — მიმღებმა იმავე ელფოსტით დაარეგისტრირა',
  'leads.activity.lostReason': 'მიზეზი: {reason}',
  'leads.activity.website': 'ვებგვერდი',
  'leads.activity.system': 'Bulk',
  'leads.field.name': 'სახელი',
  'leads.field.phone': 'ტელეფონი',
  'leads.field.email': 'ელფოსტა',
  'leads.field.source': 'წყარო',
  'leads.field.interest': 'ინტერესი',
  'leads.field.locationId': 'ფილიალი',
  'leads.field.notes': 'შენიშვნები',

  'leads.dashboard.dueToday': 'დღევანდელი კონტაქტები ლიდებთან',
  'leads.dashboard.overdue': 'ვადაგადაცილებული: {count}',
  'leads.dashboard.noneOverdue': 'ვადაგადაცილებული არ არის',

  'leads.report.title': 'ვინ წევრდება და საიდან მოდიან',
  'leads.report.description': 'პერიოდში შემოსული ლიდები და რა ბედი ეწიათ მას შემდეგ.',
  'leads.report.groupBy': 'ჩვენება',
  'reports.dataset.leads': 'ლიდები',
  'reports.grouping.source': 'წყარო',
  'reports.measure.leads': 'ლიდები',
  'reports.measure.won': 'გაწევრიანდა',
  'reports.measure.lost': 'დაიკარგა',
  'reports.measure.conversion': 'კონვერსია',
  'reports.unassigned': 'მიუმაგრებელი',
  'reports.builtIn.leadsBySource': 'ლიდების კონვერსია წყაროების მიხედვით',

  'admin.apiError.LOST_REASON_REQUIRED': 'მიუთითეთ, რატომ დაიკარგა ლიდი.',
  'admin.apiError.LEAD_CONVERTED': 'ეს ლიდი უკვე წევრია.',
  'admin.apiError.LEAD_WON_BY_CONVERTING': 'ლიდი წევრად რეგისტრაციით გადადის ეტაპზე „გაწევრიანდა“.',
  'admin.apiError.ASSIGNEE_NOT_ALLOWED': 'ლიდის მიმაგრება მხოლოდ იმ თანამშრომელზე შეიძლება, ვინც ლიდებზე მუშაობს.',
};
